import Carousel from 'react-multi-carousel';
import Spinner from '../../spinner';
import { Achievement } from '../Achievement';
import { AchievementGuestData } from '../types';
import styles from './styles.module.scss';

export const responsive = {
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

export const AchievementList = ({
  activeAchievements,
  archiveAchievements,
  isLoading
}: {
  activeAchievements: AchievementGuestData[],
  archiveAchievements: AchievementGuestData[],
  isLoading: boolean,
}) => {
  const groupedActiveAchievements = [];
  const groupedArchiveAchievements = [];
  for (let i = 0; i < activeAchievements.length; i += 4) {
    groupedActiveAchievements.push(activeAchievements.slice(i, i + 4));
  }
  for (let i = 0; i < archiveAchievements.length; i += 4) {
    groupedArchiveAchievements.push(archiveAchievements.slice(i, i + 4));
  }

  if (isLoading)
    return (
      <div className={"w-100 mb-5"} style={{ height: "400px" }}>
        <Spinner toggled={true} background={true} />
      </div>
    );

  return (
    <div className="container">
      <div className={styles.AchievementList} id='popup-achievement'>
        <div className={`${styles.AchievementList_type} d-none d-md-block`}>
          <h2 className={styles.title}>Активные</h2>
          <ul>
            {
              activeAchievements.map((ach, i) => (
                <li key={i}>
                  <Achievement
                    isActive={true}
                    achievement={ach}
                    withPopup
                  />
                </li>
              ))
            }
          </ul>
        </div>

        <div className={`${styles.CoruselContent} d-md-none`}>
          <h2 className={styles.title}>Активные</h2>
          <Carousel
            arrows={true}
            swipeable={true}
            draggable={false}
            showDots={false}
            className={styles.Carousel}
            responsive={responsive}
            itemClass={styles.CarouselItem}
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
          >
            {groupedActiveAchievements.map((group, groupIndex) => (
              <div key={groupIndex} className={styles.SlideGroup}>
                {group.map((ach, i) => (
                  <div key={i} className={styles.CarouselItem}>
                    <Achievement isActive={true} achievement={ach} withPopup />
                  </div>
                ))}
              </div>
            ))}
          </Carousel>
        </div>

        <div className={`${styles.AchievementList_type} d-none d-md-block`}>
          <h2 className={styles.title}>Архив</h2>
          <ul>
            {
              archiveAchievements.map((ach, i) => (
                <li key={i}>
                  <Achievement
                    isActive={false}
                    achievement={ach}
                    withPopup
                  />
                </li>
              ))
            }
          </ul>
        </div>

        <div className={`${styles.CoruselContent} d-md-none`}>
          <h2 className={styles.title}>Архив</h2>
          <Carousel
            arrows={true}
            swipeable={true}
            draggable={false}
            showDots={false}
            className={styles.Carousel}
            responsive={responsive}
            itemClass={styles.CarouselItem}
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
          >
            {groupedArchiveAchievements.map((group, groupIndex) => (
              <div key={groupIndex} className={styles.SlideGroup}>
                {group.map((ach, i) => (
                  <div key={i} className={styles.CarouselItem}>
                    <Achievement isActive={false} achievement={ach} withPopup />
                  </div>
                ))}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  )
};

const CustomLeftArrow = ({ onClick }: { onClick?: any }) => (
  <i onClick={() => onClick()} className={styles.left} />
);

const CustomRightArrow = ({ onClick }: { onClick?: any }) => {
  return <i className={styles.right} onClick={() => onClick()} />;
};